import { useEffect } from "react";
import { useConfig } from "@kaltura/mediaspace-shared-data-kms-config/useConfig";
import LocalIframe from "../local-iframe/LocalIframe";
import PreviewEmbedProps from "../PreviewEmbedProps";

/**
 * Preview Playlist embed in an iframe
 *
 * an iframe is used to load the relevant player lib without interfering
 * with the host page.
 */
export function PreviewEmbedPlaylist(props: PreviewEmbedProps) {
    const {
        width = 749,
        height = 422,
        title,
        partnerId,
        uiConfId,
        playlistId,
        ks,
        serviceUrl,
        cdnUrl = "https://cdnapisec.kaltura.com",
        startTime,
        endTime,
        loadThumbnailWithKs = false,
        onPlay,
    } = props;

    const {
        application: { cspNonce },
    } = useConfig();

    const playerLib = `${cdnUrl}/p/${partnerId}/embedPlaykitJs/uiconf_id/${uiConfId}`;

    const config = {
        targetId: "kaltura_player",
        provider: { partnerId, uiConfId, ks, loadThumbnailWithKs },
        env: { serviceUrl, cdnUrl },
        playback: { autoplay: false },
    };

    const script = `
        try {
            var kalturaPlayer = KalturaPlayer.setup(${JSON.stringify(config)});
            kalturaPlayer.loadPlaylist({playlistId:"${playlistId}"});
            kalturaPlayer.addEventListener(kalturaPlayer.Event.UI.USER_CLICKED_PLAY, event => {
                parent.postMessage({id: "${uiConfId}"}, '*');
            });
        } catch (e) {
            console.error(e.message)
        };`;

    const content = `
        <div class="chromatic-ignore">
            <div id="kaltura_player"></div>
            <script src="${playerLib}"></script>
            <script nonce="${cspNonce}">${script}</script>
        </div>`;

    useEffect(() => {
        const handlePlay = (ev: any) => {
            if (ev.data && Number(ev.data.id) === Number(uiConfId)) {
                onPlay?.();
                window.removeEventListener("message", handlePlay);
            }
        };
        window.addEventListener("message", handlePlay);
        return () => {
            window.removeEventListener("message", handlePlay);
        };
    }, []);

    return <LocalIframe className={"chromatic-ignore"} content={content} title={title} width={width} height={height} />;
}
export default PreviewEmbedPlaylist;
